import { getServiceTimeUnitSingularKey } from '@mews-commander/legacy-entities/src/utils/serviceTimeUnitLocalization';
import { WithServiceId } from '@mews-commander/types';
import { useCommanderSelector } from '@mews-commander/utils';
import { UnicodeEntity } from '@mews/enums';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';

export const ServiceTimeUnitRebate = ({ serviceId }: WithServiceId) => {
    const timeUnitKey = useCommanderSelector((state) => getServiceTimeUnitSingularKey(state, { id: serviceId }));
    return timeUnitKey ? (
        <>
            <LocalizedText textKey={TextKey.Rebate} />
            {UnicodeEntity.NoBreakSpace}
            {UnicodeEntity.LeftParenthesis}
            <LocalizedText textKey={timeUnitKey} />
            {UnicodeEntity.RightParenthesis}
        </>
    ) : null;
};
